import React, {useState} from "react";
import {Columns, Table} from "react-bulma-components";
import {formatDate, getFullMonthFromInt} from "../../../utils";

function getDay(date) { // get day number from 0 (monday) to 6 (sunday)
      // JS getDay return day of week 0 is Sunday 6 is Saturday
      let day = date.getDay();
      if (day == 0) day = 7; // make Sunday (0) the last day
      return day - 1;
}

export default function Calendar({year, month, onInfoClick, startThreshold, endThreshold}){
    let jsMonth = month - 1; // JS Does months 0-11 not 1-12
    let startDate = new Date(year, jsMonth, 1);

    // we need to fill the start of the calendar till the start date with blank spaces
    let firstRow = [];
    for(let i=0; i < getDay(startDate); i++){
        firstRow.push(<td className={"table-highlight-dark-grey"}></td>)
    }
    for(let i=getDay(startDate); i <=6; i++){
        let currentDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
        if(endThreshold || startThreshold){
            if(startThreshold && endThreshold){
                if(startThreshold <= currentDate && currentDate <= endThreshold){
                    firstRow.push(<td className={"on-hover-highlight clickable App"} onClick={() => onInfoClick(currentDate)}>{startDate.getDate()}</td>);
                }
                else{
                    firstRow.push(<td className={"table-highlight-dark-grey App"}>{startDate.getDate()}</td>);
                }
            }
            else if(startThreshold){
                if(startThreshold <= currentDate){
                    firstRow.push(<td className={"on-hover-highlight clickable App"} onClick={() => onInfoClick(currentDate)}>{startDate.getDate()}</td>);
                }
                else{
                    firstRow.push(<td className={"table-highlight-dark-grey App"}>{startDate.getDate()}</td>);
                }
            }
            else if(endThreshold){
                if(currentDate <= endThreshold){
                    firstRow.push(<td className={"on-hover-highlight clickable App"} onClick={() => onInfoClick(currentDate)}>{startDate.getDate()}</td>);
                }
                else{
                    firstRow.push(<td className={"table-highlight-dark-grey App"}>{startDate.getDate()}</td>);
                }
            }
        }
        else{
            firstRow.push(<td className={"on-hover-highlight clickable App"} onClick={() => onInfoClick(currentDate)}>{startDate.getDate()}</td>);
        }

        startDate.setDate(startDate.getDate()+1);
    }

    // need some kind of func that takes a start date and returns a row
    const getRow = (start) => {
        let row = [];
        for(let i=getDay(start); i <=6; i++){
            if(startDate.getMonth() === jsMonth) {
                let currentDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
                if(startThreshold || endThreshold){
                    if(startThreshold && endThreshold){
                        if(startThreshold <= currentDate && currentDate <= endThreshold){
                            row.push(<td className={"on-hover-highlight clickable App"} onClick={() => onInfoClick(currentDate)}>{startDate.getDate()}</td>);
                        }
                        else{
                            row.push(<td className={"table-highlight-dark-grey App"}>{startDate.getDate()}</td>);
                        }
                    }
                    else if(startThreshold){
                        if(startThreshold <= currentDate){
                            row.push(<td className={"on-hover-highlight clickable App"} onClick={() => onInfoClick(currentDate)}>{startDate.getDate()}</td>);
                        }
                        else{
                            row.push(<td className={"table-highlight-dark-grey App"}>{startDate.getDate()}</td>);
                        }
                    }
                    else if(endThreshold){
                        if(currentDate <= endThreshold){
                            row.push(<td className={"on-hover-highlight clickable App"} onClick={() => onInfoClick(currentDate)}>{startDate.getDate()}</td>);
                        }
                        else{
                            row.push(<td className={"table-highlight-dark-grey App"}>{startDate.getDate()}</td>);
                        }
                    }
                }
            }
            else{
                row.push(<td className={"table-highlight-dark-grey"}></td>);
            }
            startDate.setDate(startDate.getDate() + 1);
        }
        return (
            <tr>
                {row.map(item => item)}
            </tr>
        )
    }

    const getRows = (start) => {
        let rows = []
        while(start.getMonth() === jsMonth){
            rows.push(getRow(start));
        }
        return rows.map(row => row);
    }

    return (
        <div>
            <Columns>
                <Columns.Column>
                    <h2 className={"bold App"}>{getFullMonthFromInt(month)}</h2>
                </Columns.Column>
            </Columns>
            <Columns>
                <Columns.Column>
                    <Table bordered className={"table-center"}>
                        <tr>
                            <th>Mon</th>
                            <th>Tue</th>
                            <th>Wed</th>
                            <th>Thu</th>
                            <th>Fri</th>
                            <th>Sat</th>
                            <th>Sun</th>
                        </tr>
                        <tr>
                            {firstRow.map(item => item)}
                        </tr>
                        {getRows(startDate)}
                    </Table>
                </Columns.Column>
            </Columns>
        </div>
    )




}